import React, { useContext, useEffect, useState } from "react";

import Header from "../components/header";
import DashboardCard from "../components/dashboardCard";
import Footer from "../components/footer";

import { UserContext } from "../contexts/UserContext.js";
import { useNavigate } from "react-router-dom";
import IconUrls from "../enums/DashboardIconEnum.js";
import Cookies from "js-cookie";

const Dashboard = () => {
  const { userData, saveUserData, clearUserData } = useContext(UserContext);
  const [dashboardOptions, setDashboardOptions] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setDashboardOptions(userData?.modules);
    if (!userData) {
      const storedData = Cookies.get("userData");
      if (!storedData) {
        navigate("/");
      } else {
        saveUserData(JSON.parse(storedData));
      }
    }
  }, [userData]);

  return (
    <div>
      <Header />
      <div
        className="mx-auto container xl:w-full container p-6 py-16 md:pt-28
      before:content-[''] before:bottom-0 before:right-0 before:w-[200px] before:h-[220px] before:bg-cover before:bg-right-bottom before:bg-no-repeat before:fixed before:bg-[url('./assets/images/schreiber-right.svg')] before:hidden lg:before:block before:-z-10
      after:content-[''] after:bottom-0 after:left-0 after:w-[200px] after:h-[220px] after:bg-cover after:bg-left-bottom after:bg-no-repeat after:fixed after:bg-[url('./assets/images/schreiber-left.svg')] after:hidden lg:after:block after:-z-10"
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 mt-12 mb-8 sm:mt-0">
          {dashboardOptions &&
            dashboardOptions.map((card, index) => (
              <div className="w-full" key={index}>
                <DashboardCard
                  icon={IconUrls[card.applicationModuleId]}
                  title={card.moduleName}
                  content={card.content}
                  link={card.url}
                  url={card.url}
                />
              </div>
            ))}
        </div>
      </div>
      <div className="xl:absolute bottom-0 w-full relative">
        {" "}
        <Footer />{" "}
      </div>
    </div>
  );
};

export default Dashboard;
